/**
 * Playlist API Client
 *
 * Frontend wrapper for playlist/micro-scheduler CRUD operations
 */

import axios from '@/axios'

export default {
  /**
   * Get full day playlist for a channel
   * @param {number} channelId - Channel ID
   * @param {string} date - Date in YYYY-MM-DD format
   */
  async getDayPlaylist(channelId, date) {
    try {
      const response = await axios.get(`/api/playlist/${channelId}/${date}`)
      return response.data
    } catch (error) {
      console.error('Get day playlist error:', error)
      throw error
    }
  },

  /**
   * Generate playlist from week schedule and segments
   * @param {number} channelId - Channel ID
   * @param {string} date - Date in YYYY-MM-DD format
   */
  async generatePlaylist(channelId, date) {
    try {
      const response = await axios.post('/api/playlist/generate', {
        channelId,
        date
      })
      return response.data
    } catch (error) {
      console.error('Generate playlist error:', error)
      throw error
    }
  },

  /**
   * Insert item into playlist (TVC, Promo, Filler, GFX)
   * @param {Object} data - { channelId, date, afterSortOrder, mediaId, itemType, durationSeconds }
   */
  async insertItem(data) {
    try {
      const response = await axios.post('/api/playlist/insert', data)
      return response.data
    } catch (error) {
      console.error('Insert playlist item error:', error)
      throw error
    }
  },

  /**
   * Update playlist item
   * @param {Object} data - { id, ...updates }
   */
  async updateItem(data) {
    try {
      const response = await axios.put('/api/playlist/item', data)
      return response.data
    } catch (error) {
      console.error('Update playlist item error:', error)
      throw error
    }
  },

  /**
   * Remove item from playlist
   * @param {number} id - Playlist item ID
   */
  async removeItem(id) {
    try {
      const response = await axios.delete(`/api/playlist/item/${id}`)
      return response.data
    } catch (error) {
      console.error('Remove playlist item error:', error)
      throw error
    }
  },

  /**
   * Reorder playlist items (drag & drop)
   * @param {Object} data - { channelId, date, itemId, newSortOrder }
   */
  async reorderItems(data) {
    try {
      const response = await axios.put('/api/playlist/reorder', data)
      return response.data
    } catch (error) {
      console.error('Reorder playlist items error:', error)
      throw error
    }
  },

  /**
   * Auto-fill commercial breaks from channel config
   * @param {number} channelId - Channel ID
   * @param {string} date - Date in YYYY-MM-DD format
   */
  async autoFillBreaks(channelId, date) {
    try {
      const response = await axios.post('/api/playlist/auto-fill-breaks', {
        channelId,
        date
      })
      return response.data
    } catch (error) {
      console.error('Auto-fill breaks error:', error)
      throw error
    }
  },

  /**
   * Validate playlist for gaps and overlaps
   * @param {number} channelId - Channel ID
   * @param {string} date - Date in YYYY-MM-DD format
   */
  async validatePlaylist(channelId, date) {
    try {
      const response = await axios.get(`/api/playlist/validate/${channelId}/${date}`)
      return response.data
    } catch (error) {
      console.error('Validate playlist error:', error)
      throw error
    }
  }
}
